<div class="card-list">
  <div class="card-list--header">
    <air-title [title]="content.title" [region]="region" [isFirst]="isFirst">
      <a *ngIf="unifiedLink" [airLink]="unifiedLink" [userEventSource]="userEventSource" class="button button--border--transparent">
        {{ unifiedLink.label }}
      </a>
    </air-title>
  </div>
  <ul class="card-list--items grid">
    <li *ngFor="let card of cards; let i = index" class="card col-4 col-3--md col-4--sm">
      <air-card-list-item
        [description]="card.description"
        [image]="card.image"
        [link]="card.link"
        [title]="card.title"
        [userEventSource]="userEventSource"
        [step]="content.includeNumbers ? i + 1 : undefined"
      ></air-card-list-item>
    </li>
  </ul>
</div>
